<template>
  <body class="beapartner-body">
    <TextLabel labelColor="white" labelText="Wecobi Careers" />
    <div class="title">Be a Part of the Future of Sustainable Retail</div>
    <div class="text">
      Wecobi is building a circular economy for unsold inventory, transforming
      waste into opportunity. Join our team of innovators, sustainability
      advocates, and e-commerce experts who are changing the way the world
      thinks about retail.
    </div>
    <router-link to="/careers" v-if="showButton" class="button-open-positions"
      >Open Positions</router-link
    >
  </body>
</template>

<script>
import TextLabel from "@/components/Sustainability/Content/ReusableComponents/TextLabel.vue";

export default {
  name: "BeApartBanner",
  props: {
    showButton: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
  },
  components: { TextLabel },
};
</script>

<style scoped>
.beapartner-body {
  width: 100%;
  height: 462px;
  border-radius: 20px;
  background-image: url("../../../assets/company/BeAPartner.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0px 90px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  color: #ffffff;
}
.title {
  font-size: 40px;
  font-weight: 600;
  line-height: 1.2;
}
.text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
.button-open-positions {
  width: 184px;
  height: 50px;
  border: 2px solid #ffffff;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.button-open-positions:hover {
  border: 2px solid #ffffff;
  color: #000000;
  background-color: #ffffff;
}

.title,
.text {
  max-width: 702px;
}

@media (max-width: 1280px) {
  .title,
  .text {
    max-width: 478px;
  }
}
@media (max-width: 1024px) {
  .title,
  .text {
    width: 368px;
  }
  .title {
    font-size: 35px;
  }
}
@media (max-width: 744px) {
  .beapartner-body {
    padding: 0px 50px;
  }
  .title,
  .text {
    width: 286px;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 588px) {
  .beapartner-body {
    padding: 0px 50px;
  }
  .title,
  .text {
    width: 100%;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 12px;
  }
}

@media (max-width: 431px) {
  .beapartner-body {
    height: 470px;
    padding: 0px 30px;
  }
}
</style>
